<template>
  <div class="rightAll">
    <div class="rightAll-form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item :label="$t('common.num')">
          <el-select
            v-model="formInline.selectCarType"
            style="width: 120px"
            :placeholder="$t('common.form.choseTip')"
            class="selectStyle"
          >
            <el-option
              v-for="item in optionsInput"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            size="mini"
            v-model="formInline.selectCarValue"
            :placeholder="$t('common.searchTip')"
            style="width: 150px"
            class="inputStyle"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('VehicleManagement.repairTime')">
          <el-date-picker
            v-model="formInline.MaintainTime"
            type="datetimerange"
            style="width: 220px"
            size="mini"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator
            :start-placeholder="$t('common.choseTime')"
            end-placeholder
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            @click="onSearch"
            class="btn-chaxun"
            >{{ $t("common.btn.search") }}</el-button
          >
          <el-button size="mini" @click="onClear" class="btn-del">{{
            $t("common.btn.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="rightAll-btn">
      <el-button v-if="isPrimaryKey('REPAIRFORM_REMINDER')" type="text" :disabled="selected.length != 1" @click="deleteRepair">{{
        $t("common.acceptOrders")
      }}</el-button>
    </div> -->
    <i-table
      :list="list"
      :height="height"
      ref="carTable"
      @handleSelectionChange="handleSelectionChange"
      :options="option"
      :columns="columns"
      :operates="operates"
    ></i-table>
    <IPagination ref="page" @PageFun="changeSize"></IPagination>
    <!-- <el-dialog
      width="620px"
      :before-close="closeMaintainDia"
      class="addDialong"
      :title="$t('VehicleManagement.maintain')"
      :visible.sync="dialogMaintainFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :rules="MaintainRules" ref="MaintainForm" :model="MaintainForm">
        <el-form-item
          prop="requestSerialNumber"
          :label="$t('VehicleManagement.serialNumber') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            disabled
            size="small"
            v-model="MaintainForm.requestSerialNumber"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="carId"
          :label="$t('common.carId') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            disabled
            size="small"
            v-model="MaintainForm.carId"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="operateUser"
          :label="$t('VehicleManagement.operateUser') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="MaintainForm.operateUser"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="operateTime"
          :label="$t('VehicleManagement.operateTime') + ':'"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :placeholder="$t('common.btn.choseDate')"
            v-model="MaintainForm.operateTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          prop="repairType"
          :label="$t('VehicleManagement.repairType') + ':'"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="form.repairType"
            :placeholder="$t('VehicleManagement.form.repairType')"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.dictValue"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="remarks"
          :label="$t('common.remark') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="MaintainForm.remarks"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="peopleCost"
          :label="$t('VehicleManagement.peopleCost') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="MaintainForm.peopleCost"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="filePath"
          :label="$t('common.picture') + ':'"
          style="margin-top: 20px"
          :label-width="formLabelWidth"
        >
          <el-upload
            class="avatar-uploader"
            :action="processMaintainImg"
            list-type="picture-card"
            :file-list="FileMaintainList"
            :limit="4"
            :on-success="handleMaintainAvatarSuccess"
            :on-preview="handleMaintainPictureCardPreview"
            :on-remove="handleMaintainRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="dialogMaintainVisible"
            append-to-body
            class="imgForm"
          >
            <img width="100%" :src="imageMaintainUrl" alt="" class="avatar" />
          </el-dialog>
        </el-form-item>
        <div style="margin-top: 10px; font-size: 16px">
          {{ $t("VehicleManagement.repariContent") }}
        </div>
        <partsRow ref="diaTable" @computedPrice="computedPrice"></partsRow>
        <p style="text-align: right">
          {{ $t("VehicleManagement.totalMoneny") }}
          {{ MaintainForm.materialCost }}
        </p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="MaintainCancle('MaintainForm')">{{
          $t("common.btn.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitMaintainForm('MaintainForm')"
          >{{ $t("common.btn.confirm") }}</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      width="620px"
      :before-close="closeDia"
      class="addDialong"
      :title="diaTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item
          prop="carId"
          :label="$t('common.carId') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="form.carId"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="contactName"
          :label="$t('VehicleManagement.repairPerson') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="form.contactName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="happenTime"
          :label="$t('VehicleManagement.repairTime') + ':'"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :placeholder="$t('common.btn.choseDate')"
            v-model="form.happenTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          prop="phone"
          :label="$t('VehicleManagement.phone') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="form.phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="remarks"
          :label="$t('VehicleManagement.situationDescription') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="form.remarks"
            autocomplete="off"
            type="textarea"
            :rows="2"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="filePath"
          :label="$t('common.btn.uploadPicture')"
          :label-width="formLabelWidth"
          style="margin-top: 20px"
        >
          <el-upload
            class="avatar-uploader"
            :action="processImg"
            list-type="picture-card"
            :file-list="FileList"
            :limit="4"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="dialogVisible"
            append-to-body
            class="imgForm"
          >
            <img width="100%" :src="imageUrl" alt="" class="avatar" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancle('form')">{{
          $t("common.btn.cancel")
        }}</el-button>
        <el-button size="small" type="primary" @click="submitForm('form')">{{
          $t("common.btn.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="620px"
      class="addDialong"
      :title="$t('common.btn.operateDetail')"
      :visible.sync="dialogDetailsFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="DetailsRorm" :model="DetailsRorm">
        <el-form-item
          prop="carId"
          :label="$t('common.carId') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="DetailsRorm.carId"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="contactName"
          :label="$t('VehicleManagement.repairPerson') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="DetailsRorm.contactName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="happenTime"
          :label="$t('VehicleManagement.repairTime') + ':'"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :placeholder="$t('common.btn.choseDate')"
            v-model="DetailsRorm.happenTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          prop="phone"
          :label="$t('VehicleManagement.phone') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="DetailsRorm.phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="remarks"
          :label="$t('VehicleManagement.situationDescription') + ':'"
          :label-width="formLabelWidth"
        >
          <el-input
            size="small"
            v-model="DetailsRorm.remarks"
            autocomplete="off"
            type="textarea"
            :rows="2"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="filePath"
          :label="$t('common.btn.uploadPicture')"
          :label-width="formLabelWidth"
          style="margin-top: 20px"
        >
          <el-upload
            disabled
            class="avatar-uploader"
            :action="processImg"
            list-type="picture-card"
            :file-list="FileList"
            :limit="4"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="dialogVisible"
            append-to-body
            class="imgForm"
          >
            <img width="100%" :src="imageUrl" alt="" class="avatar" />
          </el-dialog>
        </el-form-item>
      </el-form>
    </el-dialog> -->
  </div>
</template>

<script>
import Processed from "./Processed.js";
export default Processed;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
